<div class="header" fxFlex [style.backgroundColor]="backgroundColor">
    <div class="header-content" [ngClass]="{ 'no-menu': !shouldShowThreeDotMenu }">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="shouldShowThreeDotMenu" class="header-menu-container">
        <button
            (menuOpened)="isMenuOpen = true"
            (menuClosed)="isMenuOpen = false"
            class="menu-btn mat-stroked-button"
            [matMenuTriggerFor]="menu"
            [attr.aria-label]="isMenuOpen ? 'close menu' : 'open menu'"
            [ngClass]="{ 'menu-open': isMenuOpen }"
        >
            <mat-icon aria-hidden="true" class="menu-icon">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <ng-container *ngFor="let option of menuOptions">
                <div
                    class="menu-option-wrapper"
                    *ngxPermissionsOnly="option.permissions"
                    (click)="onOptionWrapperClick($event, option.isEnabled)"
                >
                    <button mat-menu-item (click)="option.method()" [disabled]="!getHeaderItemValue(option.isEnabled)">
                        {{ getHeaderItemValue(option.title) }}
                        <span *ngIf="option.helpText" class="help-text">{{ getHeaderItemValue(option.helpText) }}</span>
                    </button>
                </div>
            </ng-container>
        </mat-menu>
    </div>
</div>
